import { render, staticRenderFns } from "./ModalCrearPersona.vue?vue&type=template&id=a0fc0b00"
import script from "./ModalCrearPersona.vue?vue&type=script&lang=js"
export * from "./ModalCrearPersona.vue?vue&type=script&lang=js"
import style0 from "./ModalCrearPersona.vue?vue&type=style&index=0&id=a0fc0b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports